export default "__VITE_ASSET__BaVsq4uj__"